import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule, FirebaseOptionsToken } from '@angular/fire';
import { AngularFireAuthModule, AngularFireAuth } from '@angular/fire/auth';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { FirebaseConfigService } from './firebase-config.service';

export function initializeApp(fcService: FirebaseConfigService) {
	return fcService.fireConfig();
}

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		AngularFireModule,
		AngularFireAuthModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		CoreModule,
		SharedModule,
	],
	bootstrap: [
		AppComponent
	],
	providers: [
		{
			provide: FirebaseOptionsToken,
			deps: [FirebaseConfigService],
			useFactory: initializeApp
		}
	]
})
export class AppModule {}
